import {
  SalesInsightsDashboardDefinition,
  SalesInsightsExportRequest
} from '../models/sales-insights.model';

const COLUMN_LABEL_KEYS: { [key: string]: string } = {
  key: 'SALES_INSIGHTS_COL_KEY',
  name: 'SALES_INSIGHTS_COL_NAME',
  valueBase: 'SALES_INSIGHTS_COL_VALUE_BASE',
  valueLocal: 'SALES_INSIGHTS_COL_VALUE_LOCAL',
  currency: 'SALES_INSIGHTS_COL_CURRENCY',
  quantity: 'SALES_INSIGHTS_COL_QUANTITY',
  rowCount: 'SALES_INSIGHTS_COL_ROW_COUNT',
  customerCount: 'SALES_INSIGHTS_COL_CUSTOMER_COUNT',
  orderCount: 'SALES_INSIGHTS_COL_ORDER_COUNT',
  averageOrderValue: 'SALES_INSIGHTS_COL_AVERAGE_ORDER_VALUE',
  target: 'SALES_INSIGHTS_COL_TARGET',
  customerId: 'SALES_INSIGHTS_HEALTH_COL_CUSTOMER_ID',
  customerName: 'SALES_INSIGHTS_HEALTH_COL_CUSTOMER',
  city: 'SALES_INSIGHTS_HEALTH_COL_CITY',
  email: 'SALES_INSIGHTS_HEALTH_COL_EMAIL',
  salesperson: 'SALES_INSIGHTS_HEALTH_COL_SALESPERSON',
  salespersonName: 'SALES_INSIGHTS_HEALTH_COL_SALESPERSON',
  country: 'SALES_INSIGHTS_FILTER_COUNTRY',
  lastPurchaseDate: 'SALES_INSIGHTS_HEALTH_COL_LAST_PURCHASE',
  invoicedYtd: 'SALES_INSIGHTS_HEALTH_COL_INVOICED_YTD',
  invoicedPrevYtd: 'SALES_INSIGHTS_HEALTH_COL_INVOICED_PREV_YTD',
  openOrderValue: 'SALES_INSIGHTS_HEALTH_COL_OPEN_ORDERS',
  orderId: 'SALES_INSIGHTS_COL_ORDER_ID',
  orderDate: 'SALES_INSIGHTS_COL_ORDER_DATE',
  deliveryDate: 'SALES_INSIGHTS_COL_DELIVERY_DATE',
  type: 'SALES_INSIGHTS_ACTIVITY_COL_TYPE',
  status: 'SALES_INSIGHTS_ACTIVITY_COL_STATUS',
  activityDate: 'SALES_INSIGHTS_ACTIVITY_COL_DATE',
  comment: 'SALES_INSIGHTS_ACTIVITY_COL_COMMENT',
  customerResponsible: 'SALES_INSIGHTS_ACTIVITY_COL_RESPONSIBLE',
  title: 'SALES_INSIGHTS_GOAL_TITLE',
  deadline: 'SALES_INSIGHTS_GOAL_DEADLINE',
  done: 'SALES_INSIGHTS_GOAL_DONE',
  remaining: 'SALES_INSIGHTS_COL_REMAINING',
  total: 'SALES_INSIGHTS_TOTAL'
};

const PREFIX_LABEL_KEYS: { [prefix: string]: string } = {
  current: 'SALES_INSIGHTS_CURRENT_PERIOD',
  comparison: 'SALES_INSIGHTS_PREVIOUS_PERIOD',
  previous: 'SALES_INSIGHTS_PREVIOUS_PERIOD'
};

const PREFIXED_KEYS = ['valueBase', 'valueLocal', 'quantity', 'rowCount', 'customerCount', 'orderCount', 'averageOrderValue'];

const TARGET_LABEL_KEYS: { [key: string]: string } = {
  'target.value': 'SALES_INSIGHTS_COL_TARGET',
  'target.toDate': 'SALES_INSIGHTS_COL_TARGET_TO_DATE',
  'target.attainment': 'SALES_INSIGHTS_COL_ATTAINMENT'
};

export function salesInsightsExportLabels(translate: (key: string) => string): { [key: string]: string } {
  const labels: { [key: string]: string } = {};
  Object.entries(COLUMN_LABEL_KEYS).forEach(([key, labelKey]) => (labels[key] = translate(labelKey)));
  Object.entries(PREFIX_LABEL_KEYS).forEach(([prefix, prefixKey]) =>
    PREFIXED_KEYS.forEach(key => (labels[`${prefix}.${key}`] = `${translate(prefixKey)} ${labels[key]}`))
  );
  Object.entries(TARGET_LABEL_KEYS).forEach(([key, labelKey]) => (labels[key] = translate(labelKey)));
  return labels;
}

export function salesInsightsExportTitles(
  definition: SalesInsightsDashboardDefinition,
  translate: (key: string) => string
): string[] {
  return (definition.sections || []).flatMap((section, s) =>
    (section.components || []).map((component, c) =>
      component.title ? translate(component.title) : `${s + 1}.${c + 1} ${component.type}`
    )
  );
}

export function salesInsightsExportRequest(
  definition: SalesInsightsDashboardDefinition,
  filters: { [param: string]: string[] },
  translate: (key: string) => string
): SalesInsightsExportRequest {
  return {
    filters,
    titles: salesInsightsExportTitles(definition, translate),
    labels: salesInsightsExportLabels(translate)
  };
}
